<template>
  <layout-report :renderBackAndForthFooter="false" :isProgressDone="true" :showFooter="false">
    <v-container class="padded">
      <v-row>
        <v-col cols="12">
          <v-card flat>
            <v-card-title class="text-h4 px-0">
              {{ $t("report.profile.title") }}
            </v-card-title>
            <v-card-subtitle v-html="$t('report.profile.subtitle')" class="pl-0"></v-card-subtitle>
          </v-card>
        </v-col>
      </v-row>
      <notifications />

      <v-row>
        <v-col cols="12" class="px-1">
          <v-skeleton-loader v-if="isLoading" type="list-item-three-line" />
          <profile-card v-else :user="User" />
          <Debug :debug="User" />
        </v-col>
      </v-row>
    </v-container>
  </layout-report>
</template>

<script lang="ts">
import Notifications from "@/components/thg/Notifications.vue";
import ProfileCard from "@/components/profile/ProfileCard.vue";
import Debug from "@/components/utility/Debug.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import { UserModule } from "@/store/modules/me-user.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { LayoutReport, ProfileCard, Debug, Notifications }
})
export default class UserProfile extends Vue {
  isLoading = false;

  get User() {
    return UserModule.user;
  }

  async mounted() {
    try {
      this.isLoading = true;
      await UserModule.getCurrentUser();
    } catch (e) {
      this.$log.error(e);
    } finally {
      this.isLoading = false;
    }
  }
}
</script>
